import type { Action } from 'redux';

export const CLEAR_FILTER_EDITOR = 'CLEAR_FILTER_EDITOR' as const;

export const clearFilterEditor = () => ({ type: CLEAR_FILTER_EDITOR });

export type ClearFilterEditorResponseAction = Action<typeof CLEAR_FILTER_EDITOR>;
